export default __webpack_public_path__ + "static/media/libertad.effd870e.png";